import { Controller } from "stimulus"

export default class PostEpisodePicker extends Controller {
  static targets = ["linkedPanel", "standalonePanel", "episodeIdField", "submitButton", "episodeRow"]

  connect() {
    this._selectedEpisodeId = null
    this._selectStandalone()
  }

  selectLinked() {
    this._activateLinked()
  }

  selectStandalone() {
    this._selectStandalone()
  }

  selectEpisode(event) {
    event.stopPropagation()
    const { episodeId, episodeLabel } = event.currentTarget.dataset
    this._clearSearch()
    this._chooseEpisode(episodeId, episodeLabel)
  }

  // Fired by the typeahead's <select> when a search result is picked (or cleared).
  selectSearchedEpisode(event) {
    const select = event.target
    const episodeId = select.value
    // _clearSearch clears silently, so an empty value here means the creator cleared their pick.
    if (!episodeId) {
      this._selectStandalone()
      return
    }

    const title = select.options[select.selectedIndex]?.text || ""
    const label = title.length > 20 ? `${title.slice(0, 17)}...` : title
    this._chooseEpisode(episodeId, label)
  }

  _chooseEpisode(episodeId, label) {
    this._selectedEpisodeId = episodeId
    this.episodeIdFieldTarget.value = episodeId
    this.submitButtonTarget.value = `Continue with ${label}`
    this._activateLinked()
    this.episodeRowTargets.forEach(r => this._setRowSelected(r, r.dataset.episodeId === episodeId))
  }

  _clearSearch() {
    // Silent clear so the resulting change event doesn't re-enter selectSearchedEpisode.
    this.element.querySelector("select[name='episode_search']")?.tomselect?.clear(true)
  }

  _activateLinked() {
    this.linkedPanelTarget.classList.add("border-purple-400", "bg-purple-50")
    this.linkedPanelTarget.classList.remove("border-gray-200")
    this.standalonePanelTarget.classList.remove("border-purple-400", "bg-purple-50")
    this.standalonePanelTarget.classList.add("border-gray-200")
  }

  _selectStandalone() {
    this._selectedEpisodeId = null
    this.episodeIdFieldTarget.value = ""
    this.submitButtonTarget.value = "Continue"
    this.standalonePanelTarget.classList.add("border-purple-400", "bg-purple-50")
    this.standalonePanelTarget.classList.remove("border-gray-200")
    this.linkedPanelTarget.classList.remove("border-purple-400", "bg-purple-50")
    this.linkedPanelTarget.classList.add("border-gray-200")
    this.episodeRowTargets.forEach(r => this._setRowSelected(r, false))
    this._clearSearch()
  }

  _setRowSelected(row, selected) {
    const radioEl = row.querySelector("[data-role='radio']")
    if (!radioEl) return
    const circle = radioEl.querySelector(".radio-circle")
    const dot = radioEl.querySelector(".radio-dot")
    if (selected) {
      circle?.classList.add("border-purple-500")
      circle?.classList.remove("border-gray-300")
      dot?.classList.remove("hidden")
    } else {
      circle?.classList.remove("border-purple-500")
      circle?.classList.add("border-gray-300")
      dot?.classList.add("hidden")
    }
  }
}
